import React, { useRef } from "react";
import html2pdf from "html2pdf.js";

export default function PayoutReceiptModal({
  isOpen = false,
  onClose = () => {},
  receiptData = null,
  title = "Payout Receipt",
  logoUrl = "/assets/images/logo/2.png",
}) {
  const receiptRef = useRef();

  if (!isOpen || !receiptData) return null;

  const safe = (v, def = "N/A") =>
    v === null || v === undefined || v === "" ? def : v;

  const formatCurrency = (amt) =>
    `₹${parseFloat(amt || 0).toFixed(2)}`;

  const handleDownload = () => {
    html2pdf().from(receiptRef.current).save("payout-receipt.pdf");
  };

  const handlePrint = () => {
    const w = window.open("", "_blank");
    w.document.write(receiptRef.current.innerHTML);
    w.print();
  };

  const data = receiptData;

  return (
    <div className="modal show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-md" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content" ref={receiptRef}>

          {/* HEADER */}
          <div className="modal-header">
            <img src={logoUrl} alt="Logo" style={{ height: 40 }} />
            <button className="btn-close" onClick={onClose}></button>
          </div>

          {/* BODY */}
          <div className="modal-body">
            <h4 className="text-center text-success mb-3">PAYOUT RECEIPT</h4>

            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td><strong>Status</strong></td>
                  <td className={`fw-bold ${(safe(data.status).toLowerCase() === "success" || safe(data.status).toLowerCase() === "accepted") ? "text-success" : safe(data.status).toLowerCase() === "pending" ? "text-warning" : "text-danger"}`}>
                    {safe(data.status).toUpperCase()}
                  </td>
                </tr>

                <tr>
                  <td>Ref / Order No</td>
                  <td>{safe(data.ref_no || data.order || data.ref_id)}</td>
                </tr>

                <tr>
                  <td>Ack / Txn ID</td>
                  <td>{safe(data.ack_no || data.txn_nu || data.id)}</td>
                </tr>

                <tr>
                  <td>Bank RRN</td>
                  <td>{safe(data.bank_rrn)}</td>
                </tr>

                <tr>
                  <td>Account Holder</td>
                  <td>{safe(data.holder_name)}</td>
                </tr>

                <tr>
                  <td>Account Number</td>
                  <td>{safe(data.account_number)}</td>
                </tr>

                <tr>
                  <td>Customer Mobile</td>
                  <td>{safe(data.number || data.customer)}</td>
                </tr>

                <tr>
                  <td>Amount</td>
                  <td>{formatCurrency(data.amount)}</td>
                </tr>

                <tr>
                  <td>Charge</td>
                  <td>{formatCurrency(data.Charge ?? data.charge)}</td>
                </tr>

                <tr>
                  <td>Opening Balance</td>
                  <td>{formatCurrency(data["Opening Balance"] ?? data.opening_balance)}</td>
                </tr>

                <tr>
                  <td>Closing Balance</td>
                  <td>{formatCurrency(data["Closing Balance"] ?? data.closing_balance ?? data.wallet_balance)}</td>
                </tr>

                <tr>
                  <td>Date &amp; Time</td>
                  <td>{safe(data.created_at)}</td>
                </tr>
              </tbody>
            </table>

            <p className="text-center mt-3 text-muted">
              This is a system generated payout receipt.
            </p>
          </div>

          {/* FOOTER */}
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handlePrint}>Print</button>
            <button className="btn btn-success" onClick={handleDownload}>Download</button>
            <button className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>

        </div>
      </div>
    </div>
  );
}
